import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { TIERS } from "@/data/slate";

const Pricing = () => (
    <section
        id="pricing"
        data-testid="pricing-section"
        className="border-b border-border bg-[#FAF9F6]"
    >
        <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
            <div className="grid items-end gap-10 md:grid-cols-12">
                <div className="md:col-span-8">
                    <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                        Pricing
                    </p>
                    <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.05] tracking-tight md:text-5xl">
                        Four ways to start.
                        <br />
                        <span className="italic">One Campaign</span> most leaders choose.
                    </h2>
                </div>
                <div className="md:col-span-4">
                    <p className="text-muted-foreground">
                        Flat fees. No subscriptions you forget about. Most clients pick
                        Slate Campaign — the full system, priority delivery in 48 hours.
                    </p>
                </div>
            </div>

            <div className="mt-16 grid gap-px bg-border md:grid-cols-2 lg:grid-cols-4">
                {TIERS.map((tier) => (
                    <TierCard key={tier.id} tier={tier} />
                ))}
            </div>
        </div>
    </section>
);

const TierCard = ({ tier }) => (
    <div
        data-testid={`pricing-tier-${tier.id}`}
        className={`relative flex flex-col p-8 md:p-10 ${
            tier.highlight ? "bg-primary text-primary-foreground" : "bg-card text-card-foreground"
        }`}
    >
        {tier.badge && (
            <span
                data-testid="bestseller-badge"
                className="absolute right-6 top-6 border border-primary-foreground/40 px-2 py-1 text-[10px] uppercase tracking-[0.25em]"
            >
                {tier.badge}
            </span>
        )}
        <h3 className="font-serif text-2xl font-medium tracking-tight">{tier.name}</h3>
        <p
            className={`mt-1 text-sm ${
                tier.highlight ? "text-primary-foreground/75" : "text-muted-foreground"
            }`}
        >
            {tier.tagline}
        </p>
        <p className="mt-8 font-serif text-5xl font-medium tracking-tight">{tier.priceLabel}</p>
        <ul className="mt-8 space-y-3 text-sm">
            {tier.deliverables.map((d) => (
                <li key={d} className="flex items-start gap-3">
                    <span
                        aria-hidden
                        className={`mt-1.5 inline-block h-[2px] w-3 shrink-0 ${
                            tier.highlight ? "bg-primary-foreground/70" : "bg-foreground/60"
                        }`}
                    />
                    <span>{d}</span>
                </li>
            ))}
        </ul>
        <Link
            to={`/apply?tier=${tier.id}`}
            data-testid={`pricing-cta-${tier.id}`}
            className={`mt-10 inline-flex items-center justify-between rounded-sm border px-5 py-3 text-sm font-medium transition-colors ${
                tier.highlight
                    ? "border-primary-foreground bg-primary-foreground text-primary hover:bg-card"
                    : "border-primary bg-primary text-primary-foreground hover:bg-foreground"
            }`}
        >
            {tier.cta}
            <ArrowRight size={14} strokeWidth={1.5} />
        </Link>
    </div>
);

export default Pricing;
